import { useShellStore } from '@/store'
import { ref, computed, onMounted } from 'vue'
import { Channel } from 'frontendcommon-3'
import { useShellStart } from './shell-start'
import { URLS, Auth } from '@/dashboards'

export function useTopbar (props, emit) {
  const topbarRef = ref()
  const topbarEnv = ref(process.env.VUE_APP_TOPBAR_ENV)
  const resetKey = ref(0)
  const auth = new Auth()

  const shellStore = useShellStore()
  const tokens = computed(() => shellStore.tokens)
  const showTopbar = computed(() => !props.disableTopbar && tokens.value.farmacloud.jti)
  const currentMicro = computed(() => shellStore.currentMicro)
  const { updateAuthData } = useShellStart()

  async function onSwitchUser (jti) {
    const micro = { ...currentMicro.value }
    // Set void micro for destroy current and show loader
    shellStore.SET_CURRENT_MICRO({ id: '' })
    // Get new tokens
    const data = await auth.getAuthData(jti)
    updateAuthData(data)
    // Reset extra app
    resetKey.value++
    // If current micro not exist with this session, redirect to home
    const newCurrentMicro = data.micros.find((m) => m.id === micro.id)
    if (!newCurrentMicro) {
      Channel.emitShellChangeMicro('/')
      return
    }
    // if else, relaod micro
    shellStore.SET_CURRENT_MICRO(newCurrentMicro)
  }

  // CONFIGURE TOPBAR
  onMounted(() => {
    if (showTopbar.value && typeof topbarRef.value?.setToken === 'function') {
      // TOKEN
      topbarRef.value.setToken({ token: tokens.value.farmacloud.jti })
      topbarRef.value.addEventListener('logged-in', () => { topbarRef.value.show() })
      topbarRef.value.addEventListener('logged-out', ({ detail }) => { auth.redirectLogout(detail) })
      topbarRef.value.addEventListener('logout', () => { auth.redirectLogout() })
      window.addEventListener('shell:logout', () => { topbarRef.value && topbarRef.value.logout() })
      // VISIBILITY
      topbarRef.value.addEventListener('onShowBar', () => {
        document.documentElement.style.setProperty('--fp-layout-top-space', '48px')
      })
      topbarRef.value.addEventListener('onHideBar', () => {
        document.documentElement.style.setProperty('--fp-layout-top-space', '0px')
      })
      // HELP
      if (props.helpButton && URLS.HELP_DESK_URL) {
        topbarRef.value.addEventListener('help-button-pressed', () => {
          shellStore.goToZendesk(URLS.HELP_DESK_URL)
        })
      }
      // SETTINGS
      if (props.showConfigButton) {
        topbarRef.value.addEventListener('configuration-button-pressed', () => {
          shellStore.SET_SETTINGS_SHELL(true)
        })
      }
      // SWITCH USER
      topbarRef.value.addEventListener('switch-user', ({ detail: jti }) => {
        onSwitchUser(jti)
      })
      // Emit topbar start
      emit('topbar-start', topbarRef.value)
    }
  })

  return {
    showTopbar,
    topbarRef,
    topbarEnv,
    resetKey
  }
}
